let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cOBj9"), load("jgfeV"), load("6KDUv")]).then(() => parcelRequire('iiqL3'));